export interface ComposerOptionImageReference {
    imageUrl: string;
    tempImageFileKey: string;
}

interface ComposerOptionImageNode {
    img?: string;
    data: Record<string, unknown>;
}

/**
 * Composer product saving needs the TempFile key returned by the dedicated
 * preview upload endpoint so the API can copy the bytes into the option image.
 */
export const createComposerOptionImageReference = (imageUrl: string, tempImageFileKey?: string): ComposerOptionImageReference | null => {
    if (!imageUrl) return null;
    if (!tempImageFileKey || !/^FO_\d+$/.test(tempImageFileKey)) {
        throw new Error('The option image upload did not return a valid temporary file reference.');
    }

    return {
        imageUrl,
        tempImageFileKey
    };
};

/**
 * Keep the persisted image ID while replacing its bytes. Sending -1 for an
 * existing image makes ModelDataAdapter treat the operation as a deletion.
 */
export const applyComposerOptionImage = <T extends ComposerOptionImageNode>(option: T, image: ComposerOptionImageReference | null): T =>
    ({
        ...option,
        img: image?.imageUrl ?? '',
        data: {
            ...option.data,
            imageUrl: image?.imageUrl ?? '',
            tempImageFileKey: image?.tempImageFileKey ?? '',
            tempImageFileObjectID: -1,
            imageFileObjectID: image ? (option.data?.imageFileObjectID ?? -1) : -1
        }
    }) as T;
